import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { API, IBatchResponse } from '@getgreenline/homi-shared'
import { parseErrorMsg } from '../../../../../../utilities/helpers'
import { FormError } from '../../../../../../components/FormError'

interface Props {
  companyId: number
  productId: string
  locationId: number
  batch: IBatchResponse
  onClose: () => void
}

interface State {
  isSaving: boolean
  batchNumber: string
  batchId?: number
  errorMessage: string | undefined
}

@inject('currentCompanyStore', 'currentUserStore')
@observer
export class EditLotNumberModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      batchNumber: props.batch.batchNumber,
      errorMessage: undefined,
    }
  }

  async onSubmit() {
    const { companyId, productId, locationId, batch } = this.props
    const { batchNumber } = this.state
    try {
      this.setState({ isSaving: true, errorMessage: undefined })
      await API.updateBatchById(companyId, locationId, productId, batch.id, {
        batchNumber: batchNumber,
      })
      this.props.onClose()
    } catch (error) {
      const errorMessage = parseErrorMsg(error) || 'Please try another lot number.'
      this.setState({ errorMessage })
    } finally {
      this.setState({ isSaving: false })
    }
  }

  render() {
    const { isSaving, errorMessage } = this.state
    const { batch } = this.props

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()}>
        <ModalHeader toggle={() => this.props.onClose()}>
          Edit lot # {batch.batchNumber}
        </ModalHeader>
        <ModalBody>
          <div className='text-muted mb-2'>Enter your new lot # here</div>
          <input
            className='form-control mb-2'
            defaultValue={batch.batchNumber}
            onChange={(e) => this.setState({ batchNumber: e.target.value.trim() })}
          />
          <button
            className='btn btn-lg btn-light w-100'
            disabled={isSaving}
            onClick={() => this.onSubmit()}
          >
            {isSaving ? 'Submitting...' : 'Submit'}
          </button>
          {errorMessage && (
            <div className='mt-3'>
              <FormError message={errorMessage} />
            </div>
          )}
        </ModalBody>
      </Modal>
    )
  }
}
